module.exports = __webpack_public_path__ + "static/owlin-SaCoC-4203a2acb66f876e7a59b06924fb932e.jpg";